import { Fragment, useState } from "react";

import Table from "componentsv2/table/Table";
import BodyTable from "componentsv2/table/BodyTable";
import TableHead from "componentsv2/table/TableHead";
import Loading from "componentsv2/widgets/Loading";
import ModalForm from "componentsv2/modal/ModalForm";
import Pagination from "./Pagination";
import TableEmptyState from "./TableEmptyState";
import { useStore, insertRecord } from "storev2/formStore";
import { useTable } from "storev2/tableStore";
import { cn } from "tools/ui";

const styleBase =
  "w-full overflow-y-auto ring-1 ring-neutral-200 ring-opacity-5 md:rounded-lg border mb-5 border-gray-300 shadow-md";
/**
 * Component for create table with body and header
 *
 * @param {object} props - component props
 * @param {boolean} props.sortable - boolean define if column is sortable
 * @param {Object} props.layout - define model view
 * @param {Array} props.records - Array of records to fill in
 * @param {function} props.updateRecords - Function for update records parent
 * @param {function} props.onClickRow - Function for handle event onClickRow
 * @param {function} props.onClickCell - Function for handle event onClickCell
 * @param {boolean} props.paginate - Define if table is paginate
 * @return {Component} - table component
 */
function BasicTable(props) {
  const {
    layout,
    storeId, // Id de la tabla en el store
    isLoading,
    triggerUpdate,
    offset,
    formStoreId, // Id del formulario en el store para el padre
    parentRec,
    recordStoreId,
    closeModal,
    openModal,
    records,
    reloadId,
    reload,
    onClickRow,
    handleView,
    refetch,
  } = props;
  const { model } = layout;

  const [activePage, setActivePage] = useState(1);
  const { markSelected, deleteRow } = useTable();
  const _table = useTable((state) => state[storeId]);
  const record = {};

  function selectRows(selectAll) {
    markSelected(storeId, selectAll);
    if (props.onSelectAll) {
      props.onSelectAll(selectAll);
    }
  }

  function handleSort() {}

  function updatedRecords(newData) {}

  function onChangePage(arrow, page) {
    let _activePage = activePage;
    if (page) {
      _activePage = page;
    } else if (arrow === "next") {
      _activePage = activePage + 1;
    } else {
      _activePage = activePage - 1;
    }
    props.onChangePage(_activePage);
    setActivePage(_activePage);
  }

  async function handleCloseModal(mustReload) {
    if (closeModal) {
      await closeModal(mustReload);
    }
    openModal.value = false;
    recordStoreId.value = null;
    if (mustReload) {
      if (parentRec?.record.id > 0) {
        const { reload: reloadForm } = useStore.getState();
        await reloadForm(parentRec.storeId);
      }
    }
  }

  async function onActionButton(_, action, _record) {
    openModal.value = true;
    if (action === "delete") {
      await deleteRow(storeId, _record);
      if (triggerUpdate) await triggerUpdate();
      return false;
    }
    if (layout.display === "board") {
      handleView(action, _record.id);
      return;
    }
    if (["open", "edit"].includes(action)) {
      recordStoreId.value = await insertRecord(_record.id, model, layout);
      // console.log("Seteando el record.....", recordStoreId.value);
      // currentRecordId.value = recordStoreId;
    }
  }

  if (isLoading) return <Loading />;

  let mode;
  if (record && record.id > 0) {
    mode = "edit";
  }

  //  h-[500px] is temporal fix we need set fixed height for table to apply
  // overflow scroll
  // We need think how set right fixed height before the records are setted
  let height = "h-auto";

  const totalRecords = records?.length ?? _table?.records?.length ?? 0;
  const selectedCount = _table?.selected?.size || 0;
  const allSelected = totalRecords > 0 && selectedCount === totalRecords;
  const someSelected = selectedCount > 0 && selectedCount < totalRecords;

  return (
    <Fragment>
      <div id="basic-table" className={cn(styleBase, height)}>
        <Table name={model}>
          <TableHead
            layout={layout}
            handleSort={handleSort}
            selectRows={selectRows}
            allSelected={allSelected}
            someSelected={someSelected}
          />
          {_table && (!records || records.length === 0) ? (
            <TableEmptyState type={_table?.queried ? "empty" : "filter"} />
          ) : (
            <BodyTable
              layout={layout}
              records={records || []}
              storeId={storeId}
              formStoreId={formStoreId}
              onActionButton={onActionButton}
              updatedRecords={updatedRecords}
              triggerUpdate={triggerUpdate}
              parentRec={parentRec}
              onClickRow={onClickRow}
            />
          )}
        </Table>
        {layout?.pagination !== false && (
          <Pagination
            storeId={storeId}
            lenRecords={records?.length}
            limit={layout.limit}
            offset={offset}
            layout={layout}
            onChangePage={onChangePage}
          />
        )}
      </div>
      {recordStoreId?.value && (
        <ModalForm
          layout={layout}
          onClose={handleCloseModal}
          openModal={openModal}
          parentRec={parentRec}
          reloadId={reloadId}
          reload={reload}
          storeId={recordStoreId.value}
          onClickRow={onClickRow}
          refetch={refetch}
        />
      )}
    </Fragment>
  );
}
// <ModalTable />

export default BasicTable;
